import React, { useContext, useEffect, useState } from 'react'
import { DetailRow } from '../../../components/Cards/DetailsBox'
import API from '../../../services/API'
import ConfirmCancelled from './ConfirmCancelled'
import { EventMetaContext } from './SingleEvent'
import Chip from '@mui/material/Chip'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import { TenantSettingsContext } from '../../../App'
import { useTheme } from '@emotion/react'

export const defaultEventStatuses = {
  Potential: '#242F40',
  Interested: '#3A475C',
  'Quote Sent': '#1F3D7C',
  Planning: '#E32525',
  Ready: '#00964C',
  'Event Finished': '#FADF08',
  Cancelled: '#242F40',
  'Awaiting Payment': '#242F40',
  Completed: '#3A475C',
}

const StatusChip = ({ compact = false }) => {
  const { eventMeta, loadEvent } = useContext(EventMetaContext)
  const [anchorEl, setAnchorEl] = useState(null)
  const [openCancelledConfirmation, setOpenCancelledConfirmation] =
    useState(false)
  const { orgSettings } = useContext(TenantSettingsContext).orgConfig
  const [statusOptions, setStatusOptions] = useState(defaultEventStatuses)

  let newStatus

  useEffect(() => {
    API.get('/settings?select=eventPlanningSettings.statuses').then((res) => {
      if (res.status === 200 && res?.data?.eventPlanningSettings?.statuses) {
        setStatusOptions(res?.data?.eventPlanningSettings?.statuses)
      }
    })
  }, [])

  const apiAr = {
    eventID: eventMeta._id,
    status: newStatus,
    statusUpdate: true,
    prevStatus: eventMeta.status,
  }

  const handleSelect = (newStatus) => {
    if (newStatus === 'Cancelled') {
      setOpenCancelledConfirmation(true)
    } else {
      API.put('/edit-event', { ...apiAr, status: newStatus })
        .then((res) => {
          if (res.status === 200) {
            loadEvent()
          }
          setAnchorEl(null)
        })
        .catch((e) => console.log(e))
    }
  }

  const chip = (
    <>
      <Chip
        // color={getColor(eventMeta.status)}
        label={eventMeta.status}
        onClick={(e) => setAnchorEl(e.currentTarget)}
        size="small"
        sx={{
          backgroundColor:
            typeof orgSettings?.eventPlanningSettings?.statuses === 'object' &&
            !Array.isArray(orgSettings?.eventPlanningSettings?.statuses) &&
            Object.keys(orgSettings?.eventPlanningSettings?.statuses).length > 0
              ? orgSettings?.eventPlanningSettings?.statuses[eventMeta.status]
              : statusOptions[eventMeta?.status ?? 'Completed'],
          color: '#fff',
          fontWeight: 500,
          borderRadius: 1,
        }}
      />
      <Menu
        anchorEl={anchorEl}
        open={!!anchorEl}
        onClose={() => setAnchorEl(null)}
      >
        {(Object.keys(
          orgSettings?.eventPlanningSettings?.statuses?.length ?? {},
        ).length
          ? Object.keys(orgSettings.eventPlanningSettings.statuses)
          : Object.keys(statusOptions)
        ).map((x) => (
          <MenuItem onClick={() => handleSelect(x)} key={x}>
            {x}
          </MenuItem>
        ))}
      </Menu>
      <ConfirmCancelled
        open={openCancelledConfirmation}
        setOpen={setOpenCancelledConfirmation}
        setAnchorEl={setAnchorEl}
      />
    </>
  )

  if (compact) return chip

  return (
    <DetailRow label="Status">
      {chip}
    </DetailRow>
  )
}

export default StatusChip
